module.exports = __webpack_public_path__ + "img/010-bee.961a3be9.svg";